import { useState } from "react";
import {
  Box,
  Button,
  Container,
  Paper,
  Stack,
  Switch,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
} from "@mui/material";
import PrintIcon from "@mui/icons-material/Print";
import BorderColorIcon from "@mui/icons-material/BorderColor";
import {
  addButtonPadding,
  DeletePatientButton,
  editPatientButton,
  printInvoiceButton,
  registerPatientButtonStyles,
} from "../../common/commonStyles";
import PatientResistrationForm from "./PatientResistrationForm";
import Grid from "@mui/material/Grid";
import SlotassignDialog from "./SlotManagement/SlotassignDialog";
import InvoiceApprovalDialog from "./InvoiceManagement/InvoiceApprovalDialog";
import "../../common/Common.css";
import PreviewInvoice from "./InvoiceManagement/PreviewInvoice";
import { DataGrid } from "@mui/x-data-grid";
import ReusableSnackbar from "../../shared/Alert/ReusableSnackbar";
import validators from "../../utils/validations/validators";
import DeleteIcon from "@mui/icons-material/Delete";
import { roleFlags } from "../../shared/helper";
import ServiceSelectionModal from "./ServiceSelectionModal";
import api from "../../services/api";
import PatientModal from "./PatientModal";

export default function PatientTable(props) {
  const { branchId, getPatientDetails, rows, userDetail } = props;
  const [open, setOpen] = useState(false);
  const [openServiceModal, setOpenServiceModal] = useState(false);
  const [openPatientModal, setOpenPatientModal] = useState(false);
  const [selectedServiceId, setSelectedServiceId] = useState("");
  const [isEditClicked, setIsEditClicked] = useState(false);
  const [patientId, setPatientId] = useState();
  const [serviceDetails, setServicesDetails] = useState();
  const [invoicepatientID, setInvoicePatientID] = useState();
  const [therapysessions, setTherapySession] = useState([]);
  const [therapyPlansData, settherapyPlansData] = useState([]);
  const [invoiceDetails, setInvoiceDetails] = useState();
  const [branchDetails, setBranchDetails] = useState();
  const [selectedPatient, setSelectedPatient] = useState();
  const handleCloseDialog = () => {
    setOpenServiceModal(false);
    setSelectedServiceId("");
    setOpenPatientModal(false);
  };
  const handleOpenDialog = () => setOpenServiceModal(true);
  const [formData, setFormData] = useState({
    user: {
      address: "",
      email: "",
      name: "",
      phone_number: "",
    },
    patient: {
      patient_name: "",
      date_of_birth: null,
      gender: "",
    },
  });
  const [snackbarOpen, setSnackbarOpen] = useState({
    status: false,
    message: "",
    severity: "",
  });
  const [validationErrors, setValidationErrors] = useState({});
  const [searchQuery, setSearchQuery] = useState("");
  const [dialogOpen, setDialogOpen] = useState(false);
  const [patientSlotData, setPatientSlotData] = useState({});
  const [openInvoiceDialog, setOpenInvoiceDialog] = useState(false);
  const [showPreview, setShowPreview] = useState(false);
  const [showTable, setShowTable] = useState(true);

  const handleSnackClose = () => setSnackbarOpen(false);
  const handleOpen = () => setOpen(true);

  const handleClose = (event, reason) => {
    if (reason === "backdropClick") {
      return;
    }
    if (reason === "escapeKeyDown") {
      return;
    }
    setFormData({
      user: {
        address: "",
        email: "",
        name: "",
        phone_number: "",
      },
      patient: {
        patient_name: "",
        date_of_birth: null,
        gender: "",
        profile_pic_path: "",
      },
    });
    setIsEditClicked(false);
    setValidationErrors({});
    setOpen(false);
  };

  const BASE_URL = process.env.REACT_APP_API_BASE_URL;
  const APP_URL = process.env.REACT_APP_URL;

  const DEFAULT_IMAGE =
    BASE_URL + "/static/profile_pic/default_profile_pic.png";
  const flags = roleFlags(userDetail?.role);

  const columns = [
    {
      field: "profile_pic_path",
      headerName: "",
      flex: 0.5, // small proportional space
      minWidth: 80,
      sortable: false,
      editable: false,
      renderCell: (params) => {
        const imagePath = params.row.profile_pic_path
          ? `${BASE_URL}${params.row.profile_pic_path}`
          : DEFAULT_IMAGE;
        const isDefault = !params.row.profile_pic_path;

        // Handler for file input change
        const handleImageUpload = async (event, patient_id) => {
          const file = event.target.files[0];
          if (!file) {
            setSnackbarOpen({
              status: true,
              message: "Please select an image file to upload.",
              severity: "error",
            });
            return;
          }
          const formData = new FormData();
          formData.append("file", file);
          try {
            let uploadImage = await api.post(
              `app/patient/add_patient_profile_pic/${patient_id}`,
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data",
                },
              },
            );
            if (uploadImage.status === 200) {
              setSnackbarOpen({
                status: true,
                message: "Profile picture uploaded successfully!",
              });
              getPatientDetails();
            }
          } catch (error) {
            setSnackbarOpen({
              message: error?.response?.data?.detail || "An error occurred",
              severity: "error",
            });
          }
          getPatientDetails(); // Refresh table after upload
        };
        // Reference for the hidden file input
        const inputId = `upload-input-${params.row.id}`;
        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
              cursor: "pointer",
              position: "relative",
            }}
            onClick={() => {
              document.getElementById(inputId).click();
            }}
            title={isDefault ? "Click to upload image" : ""}
          >
            <img
              src={imagePath}
              alt="Profile"
              style={{
                width: 40,
                height: 40,
                borderRadius: "50%",
                objectFit: "cover",
              }}
              onError={(e) => {
                e.target.onerror = null; // avoid infinite loop
                e.target.src = DEFAULT_IMAGE;
              }}
            />
            <input
              id={inputId}
              type="file"
              accept="image/*"
              capture="environment"
              style={{ display: "none" }}
              onChange={(event) => handleImageUpload(event, params.row.id)}
            />
          </div>
        );
      },
    },
    {
      field: "patient_name",
      headerName: "Name",
      flex: 1,
      minWidth: 150,
      editable: false,
      renderCell: (params) => (
        <span
          style={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => handleNameClick(params.row)}
        >
          {params.value}
        </span>
      ),
    },
    {
      field: "age",
      headerName: "Age",
      flex: 0.6,
      minWidth: 100,
      editable: false,
    },
    {
      field: "name",
      headerName: "Parent Name",
      flex: 1,
      minWidth: 150,
      editable: false,
    },
    {
      field: "phone_number",
      headerName: "Mobile",
      flex: 1,
      minWidth: 130,
      editable: false,
    },
    {
      field: "created_date",
      headerName: "Created Date",
      flex: 1,
      minWidth: 180,
      type: "dateTime", // or "date"
      valueGetter: (params) => (params ? new Date(params) : null), // string -> Date

      // 👇 format the Date into your desired display
      valueFormatter: (params) => {
        if (!params) return "";
        const date = params;
        return date.toLocaleString("en-IN", {
          day: "2-digit",
          month: "2-digit",
          year: "numeric",
          hour: "2-digit",
          minute: "2-digit",
        });
      },
    },

    {
      field: "is_active",
      headerName: "Is Active",
      flex: 0.8,
      minWidth: 120,
      editable: false,
      sortable: false,
      renderCell: (param) => (
        <Switch
          defaultChecked={param.row.is_active}
          onChange={(event) => handleToggleIsActive(event, param.row)}
        />
      ),
    },
    {
      field: "is_slot_allocated",
      headerName: "Is Slot Assigned",
      flex: 1.2,
      minWidth: 160,
      editable: false,
      sortable: false,
      renderCell: (param) => (
        <Box className="center-align">
          {param.row.is_slot_allocated ? (
            <Button
              size="small"
              onClick={() => {
                handleEditSlot(param.row.id);
              }}
              sx={{ fontSize: "12px", textTransform: "none" }}
            >
              See Slot Details
            </Button>
          ) : (
            <Switch
              defaultChecked={param.row.is_slot_allocated}
              onChange={(event) => {
                if (event.target.checked) {
                  handleClickOpen(param.row.id);
                }
              }}
            />
          )}
        </Box>
      ),
    },
    {
      field: "action",
      headerName: "Action",
      flex: 0.8,
      minWidth: 140,
      editable: false,
      sortable: false,
      renderCell: (params) => {
        const isActive = params.row.is_active;

        return (
          <div
            style={{
              display: "flex",
              justifyContent: "center",
              alignItems: "center",
              width: "100%",
              height: "100%",
            }}
          >
            <PrintIcon
              sx={{
                ...printInvoiceButton,
                color: isActive ? undefined : "#ccc",
                pointerEvents: isActive ? "auto" : "none",
              }}
              onClick={() => {
                if (isActive) {
                  handlegetInvoice(
                    params.row.id,
                    params.row.patient_name,
                    params.row.branch_id,
                    params.row.patient_name,
                    params.row.is_slot_allocated,
                  );
                }
              }}
            />
            <BorderColorIcon
              sx={{
                ...editPatientButton,
                color: isActive ? undefined : "#ccc",
                pointerEvents: isActive ? "auto" : "none",
              }}
              onClick={() => {
                if (isActive) {
                  handlePatientEdit(params.row.id);
                }
              }}
            />
            {flags.isReceptionist ? (
              <></>
            ) : (
              <DeleteIcon sx={DeletePatientButton} onClick={() => handleDeletePatient(params.row)} />
            )}
          </div>
        );
      },
    },
  ];
  const handleNameClick = (row) => {
    setOpenPatientModal(true);
    setSelectedPatient(row); // Store the clicked patient's data in state for use in the modal
  };
  const hanldleAgreePresent = async () => {
    if (!selectedServiceId) {
      setSnackbarOpen({
        status: true,
        message: "Please Choose Service first.",
        severity: "warning",
      });
      return;
    }
    const url =
      APP_URL +
      `/consultation-invoice?patient_id=${invoicepatientID}&service_id=${selectedServiceId}`;
    window.open(url, "_blank");
  };
  const handlePreview = async (id, branchId) => {
    try {
      // Run both API calls in parallel
      await Promise.all([
        generateInvoiceDetails(id),
        getbranchDetails(branchId),
      ]);

      // If both succeed → open preview
      setShowPreview(true);
      setShowTable(false);
    } catch (error) {
      console.error("Error fetching preview data:", error);
      // Optionally show error message to user
      alert("Failed to load preview. Please try again.");
    }
  };

  const handleInputChange = (e) => {
    const { name, value } = e.target;

    // Update form data
    if (["address", "email", "name", "phone_number"].includes(name)) {
      setFormData((prev) => ({
        ...prev,
        user: {
          ...prev.user,
          [name]: value,
        },
      }));
    } else if (
      ["patient_name", "date_of_birth", "gender", "profile_pic_path"].includes(
        name,
      )
    ) {
      setFormData((prev) => ({
        ...prev,
        patient: {
          ...prev.patient,
          [name]: value,
        },
      }));
    }

    // Validate live
    if (validators[name]) {
      const errorMsg = validators[name](value);
      setValidationErrors((prev) => ({
        ...prev,
        [name]: errorMsg,
      }));
    }
  };

  // Check if form valid
  const requiredUserFields = ["address", "email", "name", "phone_number"];
  const requiredPatientFields = ["patient_name", "date_of_birth", "gender"];

  const isFormValid =
    Object.values(validationErrors).every((err) => err === "") &&
    requiredUserFields.every((key) => formData.user[key]?.trim() !== "") &&
    requiredPatientFields.every((key) => formData.patient[key]?.trim() !== "");

  function getFilteredServicesByBranch(servicesData, branchId) {
    if (!Array.isArray(servicesData)) return [];

    return servicesData.filter((service) => service.branch_id === branchId);
  }
  const filteredRows = rows?.filter((row) =>
    Object.values(row).some(
      (val) =>
        val && val.toString().toLowerCase().includes(searchQuery.toLowerCase()),
    ),
  );

  const handleClickOpen = async (id) => {
    await getServices();
    await getTherapyPlans(id);
    setDialogOpen(true);
    setPatientId(id);
    setPatientSlotData({});
  };
  const getServices = async () => {
    let servicesData = await api.get(`app/management/therapy-service/`);
    setServicesDetails(
      getFilteredServicesByBranch(servicesData?.data, branchId),
    );
  };

  const getTherapyPlans = async (id) => {
    let therapyData = await api.get(
      `app/patient/therapy_plans/?filter_by_today=false&patient_id=${id}&branch_id=${branchId}`,
    );
    settherapyPlansData(therapyData?.data);
  };
  const formatDate = (dateStr) => {
    const date = new Date(dateStr);
    const day = String(date.getDate()).padStart(2, "0");
    const month = String(date.getMonth() + 1).padStart(2, "0");
    const year = String(date.getFullYear()).slice(-2);
    return `${day}-${month}-${year}`;
  };

  function getInvoiceSessions(data) {
    const filteredSessions = data?.sessions.filter(
      (session) => session.exclude_from_invoice === false,
    );

    const totalAmount = filteredSessions.reduce(
      (sum, session) => sum + (session.therapy_fee || 0),
      0,
    );

    return {
      ...data,
      sessions: filteredSessions,
      session_count: filteredSessions.length,
      total_amount: totalAmount,
    };
  }

  const handleEditSlot = async (id) => {
    setPatientId(id);
    await getServices();
    await getTherapyPlans(id);
    setDialogOpen(true);
  };
  const handleDialogClose = () => {
    setDialogOpen(false);
  };

  const handleCreatePatient = async () => {
    if (!isFormValid) {
      setSnackbarOpen({
        status: true,
        message: "Please fill all required fields correctly.",
        severity: "error",
      });
      return;
    }
    if (isEditClicked) {
      sendPatientEdit();
    } else {
      try {
        const response = await api.post(`app/patient/${branchId}`, formData);
        if (response.status === 200) {
          setFormData({
            user: {
              address: "",
              email: "",
              name: "",
              phone_number: "",
            },
            patient: {
              patient_name: "",
              date_of_birth: null,
              gender: "",
              profile_pic_path: "",
            },
          });
          setSnackbarOpen({
            status: true,
            message: "Patient added successfully!",
            severity: "success",
          });
          setIsEditClicked(false);
          handleClose();
          getPatientDetails();
        }
      } catch (error) {
        setSnackbarOpen({
          status: true,
          message: error?.response?.data?.detail || "An error occurred",
          severity: "error",
        });
      }
    }
  };
  const getDetailsPatientWise = async (id) => {
    let patientIdData = await api.get(`app/patient/${id}`, {});
    {
      const updatedData = {
        user: {
          address: patientIdData?.data.address,
          email: patientIdData?.data.email,
          name: patientIdData?.data.name,
          phone_number: patientIdData?.data.phone_number,
        },
        patient: {
          patient_name: patientIdData?.data.patient_name,
          date_of_birth: patientIdData?.data.date_of_birth,
          gender: patientIdData?.data.gender,
          profile_pic_path: "",
        },
      };

      setFormData(updatedData);
    }
  };
  const sendPatientEdit = async () => {
    setIsEditClicked(true);
    try {
      let updatedPatientData = await api.put(
        `app/patient/${patientId}`,
        formData,
      );
      if (updatedPatientData.status === 200) {
        setFormData({
          user: {
            address: "",
            email: "",
            name: "",
            phone_number: "",
          },
          patient: {
            patient_name: "",
            date_of_birth: null,
            gender: "",
            profile_pic_path: "",
          },
        });
        setSnackbarOpen({
          status: true,
          message: "Patient Data Edited successfully !",
          severity: "success",
        });
        setIsEditClicked(false);
        handleClose();
        getPatientDetails();
      }
    } catch (error) {
      setSnackbarOpen({
        message: error?.response?.data?.detail || "An error occurred",
        severity: "error",
      });
    }
  };
  const handlePatientEdit = async (id) => {
    setPatientId(id);
    setIsEditClicked(true);
    await getDetailsPatientWise(id);
    handleOpen();
  };

  const handleDeletePatient = async (row) => {
    if (window.confirm(`Are you sure you want to delete patient ${row.patient_name}?`)) {
      try {
        let deleteResponse = await api.delete(`app/patient/${row.id}`);
        console.log("Delete response:", deleteResponse);
        if (deleteResponse.status === 200) {
          setSnackbarOpen({
            status: true,
            message: "Patient deleted successfully!",
            severity: "success",
          });
          getPatientDetails();
        }
      } catch (error) {
        setSnackbarOpen({
          message: error?.response?.data?.detail || "An error occurred",
          severity: "error",
        });
      }
    }
  };
  const handleSlotSubmit = async (slotDataList) => {
    try {
      const response = await api.put(
        `app/patient/assign_therapy_plan/${patientId}`,
        slotDataList,
      );
      if (response?.status === 200) {
        setSnackbarOpen({
          status: true,
          message: "Patient slot assigned successfully!",
          severity: "success"
        });
      }
    } catch (error) {
      setSnackbarOpen({
        severity: "error",
        status: true,
        message: "Something went wrong! pleas try again",
      });
    }
    await getTherapyPlans(patientId);
    getPatientDetails();
  };
  const handlePatientSlotDelete = async (recordID) => {
    try {
      const response = await api.delete(
        `app/patient/therapy_plans/${recordID}`,
      );
      if (response?.status === 200) {
        setSnackbarOpen({
          status: true,
          message: response?.data?.message || "Service Deleted successfully!",
          severity:"success"
        });
      }
    } catch (error) {
      setSnackbarOpen({
        severity: "error",
        status: true,
        message: "Something went wrong! pleas try again",
      });
    }
    await getTherapyPlans(patientId);
    getPatientDetails();
  };

  const handlePatientSlotEdit = async (slotDataList, recordID) => {
    try {
      const response = await api.put(
        `app/patient/therapy_plans/${recordID}`,
        slotDataList,
      );
      if (response?.status === 200) {
        setSnackbarOpen({
          status: true,
          message: "Service added successfully!",
          severity:"success"
        });
      }
    } catch (error) {
      setSnackbarOpen({
        severity: "error",
        status: true,
        message: "Something went wrong! pleas try again",
      });
    }
    await getTherapyPlans(patientId);
    getPatientDetails();
  };

  const handlegetInvoice = async (
    id,
    name,
    branchId,
    patientName,
    isSlotAssigned,
  ) => {
    setInvoicePatientID(id);
    let checkInvoiceStatus = await api.get(
      `app/patient/therapy_plans/${id}/invoice/status`,
    );

    if (isSlotAssigned) {
      if (checkInvoiceStatus?.data?.published === true) {
        const url =
          APP_URL + `/invoice?slug=${checkInvoiceStatus?.data?.slug}/`;
        window.open(url, "_blank");
      }

      if (checkInvoiceStatus?.data?.published === false) {
        FungetTherapySession(id, checkInvoiceStatus?.data?.published);
      }
    } else {
      handleOpenDialog();
    }
  };

  const FungetTherapySession = async (id) => {
    let getTherapySession = await api.get(
      `app/patient/therapy_plans/${id}/sessions/`,
    );
    if (getTherapySession.status === 200) {
      setOpenInvoiceDialog(true);
      setTherapySession(getTherapySession?.data);
    }
  };
  const handleExcludeFromInvoice = async (id, status) => {
    let excludeResponse = await api.patch(
      `app/patient/therapy-sessions/${id}/exclude?exclude=${!status}`,
      {},
    );
    if (excludeResponse?.status === 200) {
      setSnackbarOpen({
        message: excludeResponse?.data.message,
        severity: "success",
      });
    }
  };
  const generateInvoiceDetails = async (id) => {
    let response = await api.get(`app/patient/therapy_plans/${id}/invoice/`);
    if (response?.status === 200) {
      const invoiceData = getInvoiceSessions(response?.data);
      setInvoiceDetails(getInvoiceSessions(invoiceData));
    }
  };
  const getbranchDetails = async (branch_id) => {
    let response = await api.get(
      `app/management/branches/?branch_id=${branch_id}`,
    );
    if (response?.status === 200) {
      setBranchDetails(response?.data[0]);
    }
  };
  const handlePublish = async (id) => {
    try {
      let publishResponse = await api.post(
        `app/patient/therapy_plans/${id}/invoice/publish`,
        {},
      );
      if (publishResponse?.status === 200) {
        setSnackbarOpen({
          status: true,
          message: publishResponse?.data.message,
          severity:"success"
        });
        setOpenInvoiceDialog(false);
        getPatientDetails();
      } else {
        setSnackbarOpen({
          status: true,
          message: "Something went wrong! please try again",
          severity: "error",
        });
        setOpenInvoiceDialog(false);
        getPatientDetails();
      }
    } catch (error) {
      alert(error?.response?.data?.detail);
      setOpenInvoiceDialog(false);
      getPatientDetails();
    }
  };

  const handleToggleIsActive = async (event, row) => {
    const newValue = event.target.checked;
    try {
      await api.put(`app/patient/${row.id}/`, {
        user: {},
        patient: { is_active: newValue },
      });
      if (typeof getPatientDetails === "function") {
        getPatientDetails(); // parent should refetch and pass updated `rows` again
      }
    } catch (error) {
      console.error("Failed to update status:", error);
    }
  };

  return (
    <>
      <Box className="tabcontent_box">
        <Grid
          container
          spacing={2}
          className="patientTable-btnstack"
          display="flex"
          alignItems="center"
        >
          <Grid size={8}>
            <Button
              variant="contained"
              sx={[registerPatientButtonStyles, addButtonPadding]}
              size="small"
              onClick={handleOpen}
            >
              Add New Patient
            </Button>
          </Grid>
          <Grid size={4} sx={{ textAlign: "right" }}>
            <TextField
              size="small"
              placeholder="Search ..."
              value={searchQuery}
              onChange={(e) => setSearchQuery(e.target.value)}
            />
          </Grid>
        </Grid>

        <DataGrid
          sx={{
            fontFamily: "Nunito, sans-serif",
            // Cell (row content) font size
            "& .MuiDataGrid-cell": {
              fontSize: "12px",
            },

            // Header font size
            "& .MuiDataGrid-columnHeaderTitle": {
              fontSize: "13px",
              fontWeight: "bold",
            },
          }}
          rows={filteredRows}
          columns={columns}
          initialState={{
            pagination: {
              paginationModel: {
                pageSize: 10,
              },
            },
          }}
          pageSizeOptions={[5]}
          // checkboxSelection
          disableRowSelectionOnClick
        />
      </Box>
      <PatientResistrationForm
        open={open}
        handleOpen={handleOpen}
        handleClose={handleClose}
        formData={formData}
        setFormData={setFormData}
        handleInputChange={handleInputChange}
        handleCreatePatient={handleCreatePatient}
        isEditClicked={isEditClicked}
        validationErrors={validationErrors}
        isFormValid={isFormValid}
      />
      <SlotassignDialog
        open={dialogOpen}
        onClose={handleDialogClose}
        handleSlotSubmit={handleSlotSubmit}
        initialData={patientSlotData}
        serviceDetails={serviceDetails}
        therapyPlansData={therapyPlansData}
        handlePatientSlotDelete={handlePatientSlotDelete}
        handlePatientSlotEdit={handlePatientSlotEdit}
        branchId={branchId}
      />
      <InvoiceApprovalDialog
        open={openInvoiceDialog}
        onClose={() => setOpenInvoiceDialog(false)}
        onSave={() => {
          setOpenInvoiceDialog(false);
        }}
        title="Invoice Approval Board"
      >
        <Container className="invoice_grid">
          <Grid container spacing={2}>
            {showTable && (
              <Grid size={12}>
                <TableContainer component={Paper} className="patient-table">
                  <Stack
                    direction="row"
                    spacing={2}
                    className="patientTable-btnstack"
                  ></Stack>
                  <Table sx={{ minWidth: 650 }}>
                    <TableHead>
                      <TableRow>
                        <TableCell
                          align="center"
                          className="tablecell-text"
                          style={{ fontWeight: "bold" }}
                        >
                          Service Name
                        </TableCell>
                        <TableCell
                          align="center"
                          className="tablecell-text"
                          style={{ fontWeight: "bold" }}
                        >
                          Session Date
                        </TableCell>
                        <TableCell
                          align="center"
                          className="tablecell-text"
                          style={{ fontWeight: "bold" }}
                        >
                          Attended
                        </TableCell>
                        <TableCell
                          align="center"
                          className="tablecell-text"
                          style={{ fontWeight: "bold" }}
                        >
                          Notes
                        </TableCell>
                        <TableCell
                          align="center"
                          className="tablecell-text"
                          style={{ fontWeight: "bold" }}
                        >
                          Exclude From Invoice
                        </TableCell>
                        <TableCell> </TableCell>
                      </TableRow>
                    </TableHead>
                    <TableBody>
                      {Array.isArray(therapysessions) &&
                        therapysessions?.map((row) => (
                          <TableRow
                            key={row.name}
                            sx={{
                              "&:last-child td, &:last-child th": { border: 0 },
                            }}
                          >
                            <TableCell
                              align="center"
                              className="tablebody-text"
                            >
                              {row.service_name}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="tablebody-text"
                            >
                              {formatDate(row.session_date)}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="tablebody-text"
                            >
                              {row.attended ? "Present" : "Absent"}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="tablebody-text"
                            >
                              {row.notes}
                            </TableCell>
                            <TableCell
                              align="center"
                              className="tablebody-text"
                            >
                              {" "}
                              <Switch
                                defaultChecked={row.exclude_from_invoice}
                                disabled={row.attended}
                                onClick={() => {
                                  handleExcludeFromInvoice(
                                    row.id,
                                    row.exclude_from_invoice,
                                  );
                                }}
                              />
                            </TableCell>
                          </TableRow>
                        ))}
                    </TableBody>
                  </Table>
                </TableContainer>
              </Grid>
            )}
          </Grid>
          {showPreview && (
            <PreviewInvoice
              invoiceDetails={invoiceDetails}
              branchDetails={branchDetails}
            />
          )}
          <Grid container spacing={2} justifyContent="flex-end" sx={{ mt: 2 }}>
            <Grid item>
              {!showPreview && (
                <Button
                  variant="contained"
                  className="attenadance_btn"
                  onClick={() => {
                    handlePreview(invoicepatientID, branchId);
                  }}
                >
                  Preview
                </Button>
              )}
            </Grid>
            <Grid item>
              <Button
                variant="contained"
                className="attenadance_btn"
                onClick={() => {
                  handlePublish(invoicepatientID);
                }}
              >
                Publish
              </Button>
            </Grid>
          </Grid>
        </Container>
      </InvoiceApprovalDialog>
      <ReusableSnackbar
        open={snackbarOpen.status}
        message={snackbarOpen.message}
        onClose={handleSnackClose}
        severity={snackbarOpen.severity}
      />
      <ServiceSelectionModal
        open={openServiceModal}
        title="Choose Service"
        description={
          "select the service from below deropdown for which you want to generate the invoice"
        }
        agreeText="Yes"
        disagreeText="Cancel"
        onClose={handleCloseDialog}
        onAgree={hanldleAgreePresent}
        setSelectedServiceId={setSelectedServiceId}
        selectedServiceId={selectedServiceId}
        invoicepatientID={invoicepatientID}
        branchId={branchId}
      />
       <PatientModal
        open={openPatientModal}
        onClose={handleCloseDialog}
        selectedPatient={selectedPatient}
      />
    </>
  );
}
